// extracted by mini-css-extract-plugin
module.exports = {"container":"sa","overlay":"ta","headingSection":"ua","close":"va","copy":"wa","m-heart-activate":"xa","bottomSection":"ya","signInButton":"za","disabled":"Aa","m-heart-pulse":"Ba"};